import React, { useContext } from "react";
import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";
import { IdentityContext, UserManagerContext } from "@react-beets/identity";
import { GetReturnUrl } from "../../../utils";

function LoginButton() {
  const { userManager } = useContext(UserManagerContext);
  const { login } = useContext(IdentityContext);
  const { identity } = useContext(IdentityContext);

  if (identity) return null;

  const handleLogin = async () => {
    if (!userManager) return;
    const returnUrl = GetReturnUrl();
    const signInArguments = {
      useReplaceToNavigate: true,
      data: { returnUrl: `${returnUrl}app` },
    };
    try {
      await userManager.signinRedirect(signInArguments);
      const user = await userManager.getUser();
      await login(user);  
    } catch(e) {
      console.error("Error loggin in", e);
    }
  };

  return (
    <ListItem onClick={handleLogin} button={true}>
      <ListItemIcon>
        <LoginIcon />
      </ListItemIcon>
      <ListItemText primary="Login" />
    </ListItem>
  );
}

export default LoginButton;
